<template>
  <div>
    <app-history @clicked="$router.push('/madrak-request')" title="درخواست مدرک تحصیلی" />
    <app-history @clicked="$router.push('/madrak-history')" title="سوابق درخواست مدرک تحصیلی" />

    <div v-if="isMobile">
      <app-madrak v-for="index in history.length" :key="index" :index="index - 1" :item="history[index - 1]"
        :selectedItem="selectedItem" @clicked="onClickItem" @removeRequest="removeRequest"
        @callDownload="callDownloadFromCard" @showPostRequestForm="handleShowPostRequstForm">
      </app-madrak>
    </div>
    <div v-else>
      <v-data-table :items="history" item-key="Fserial" :headers="historyHeaders" class="elevation-1 rounded"
        :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText">
        <!-- <template v-slot:[`item.post`]="{ item }">
          <app-status :item="item" @showPostRequestForm="handleShowPostRequstForm" />
        </template> -->
      </v-data-table>
    </div>
    <!-- <v-dialog v-model="showPostRequestForm" width="500"><app-post @onClose="onClosePostReqForm"
        @setStep="handlePostRequestStep" :madrak="selectedMadrak"
        :postRequestStep="postReqestStepComputed" /></v-dialog> -->
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Madrak from "./Madrak";
import HistoryButton from "@/components/HistoryButton";
import PostRequest from "./PostRequest";
import DetailRow from "@/components/DetailRow";
import StatusButton from "./StatusButton.vue";

import Dialog from "@/components/Dialog";
import {
  removeMadrakRequest,
  downloadAttach,
  getMadrakAll,
} from "@/api/madrak";
import { getPostRequest } from "@/api/post";
import { saveByteArray } from "@/utils/constants";
import {
  PostRequestStep_Enum,
  PostRequestState_Enum,
  Jensiat_Enum,
} from "@/utils/constants";
import { getJensiat } from "../../utils/auth";
export default {
  components: {
    appMadrak: Madrak,
    appDialog: Dialog,
    appHistory: HistoryButton,
    appPost: PostRequest,
    appRow: DetailRow,
    appStatus: StatusButton,
  },
  data() {
    return {
      PostRequestState_Enum: PostRequestState_Enum,
      postRequestStep: PostRequestStep_Enum.PostRequest,
      showPostRequestForm: false,
      showPaymentForm: false,
      selectedMadrak: {},
      selectedItem: -1,
      history: [],
      historyHeaders: [
        {
          text: "شماره",
          value: "DiplomId",
          width: "10%",

        },
        {
          text: "سطح",
          value: "Sath",
          width: "5%",
        },
        {
          text: "رشته",
          value: "Field",
          width: "10%",
        },
        {
          text: "صادر کننده",
          value: "SchoolName",
          width: "20%",
        },
        {
          text: "معدل",
          value: "Average",
          width: "5%",
        },
        {
          text: "تاریخ اتمام",
          value: "DiplomaDate",
          width: "10%",
        },
        {
          text: "تاریخ صدور",
          value: "SodoorDate",
          width: "10%",
        },

        { text: "وضعیت", value: "StrState", width: "10%" },
        {
          text: "",
          value: "post",
          width: "20%",
          sortable: false,

        },
      ],
    };
  },
  async created() {
    try {
      this.history = await this.getAllMadarek();

      this.$store.commit("SET_TABLE_TEXT", false);
    } catch (error) {
      this.$store.commit(
        "SET_SNACKBAR_TEXT",
        "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
      );
    }
  },
  computed: {
    postReqestStepComputed() {
      return this.postRequestStep;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    getAllMadarek() {
      return new Promise((resolve, reject) => {
        getMadrakAll()
          .then((response) => {
            let madareks = [];
            if (response && response?.data) {
              response.data.map((madrak) => {
                getPostRequest(madrak.DiplomSerial)
                  .then((postInfo) => {
                    madareks.push({
                      ...madrak,
                      postInfo: postInfo?.data ?? null,
                    });
                    resolve(madareks);
                  })
                  .catch((error) => {
                    throw error;
                  });
              });
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async handlePostRequestStep(step) {
      try {
        this.history = await this.getAllMadarek();
        let updatedSelectedMadrak = this.history.findIndex(
          (madrak) => madrak.DiplomId === this.selectedMadrak?.DiplomId
        );
        if (updatedSelectedMadrak !== -1)
          this.selectedMadrak = this.history[updatedSelectedMadrak];
        this.postRequestStep = step;
        this.$store.commit("SET_TABLE_TEXT", false);
      } catch (error) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
        );
      }
    },
    handleShowPostRequstForm(item) {
      const jens = getJensiat();
      if (jens === Jensiat_Enum.Male) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "این درخواست برای برادران فعال نیست"
        );
      } else {
         this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "فعلاً براي دريافت مدرك حضوراً به مركز مديريت حوزه علميه خراسان مراجعه شود."
        );
        // if (
        //   item.postInfo &&
        //   item.postInfo.State === this.PostRequestState_Enum.NotPaid
        // ) {
        //   this.postRequestStep = PostRequestStep_Enum.PostPayment;
        // }
        // this.selectedMadrak = item;
        // this.showPostRequestForm = true;
      }
    },
    onClosePostReqForm() {
      this.showPostRequestForm = false;
    },
    showPostRequstStatus(item) { },
    /**
     * expand khorooj
     */
    onClickItem(index) {
      if (this.selectedItem != index) {
        this.selectedItem = index;
      } else {
        this.selectedItem = -1;
      }
    },
    /**
     * show confirm dialog
     */
    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        removeMadrakRequest(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.$store.dispatch("getMadrakHistory");
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    callDownloadFromCard(data) {
      this.callDownload(data.index, data.step, data.token);
    },
    callDownload(index, step, token) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadAttach(index, step, token)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}
</style>
